// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"b216049c17f1a7e25d3e","4585":"0ff00228d165c0540e3c","6723":"ce0e7014605e082fd26d"}[chunkId] + ".css";
};